(function () {
  'use strict';

  // Collection sorting
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Product page
  var root = document.querySelector('[data-product]');
  if (!root) return;

  var dataEl = root.querySelector('[data-variants]');
  var idInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-price]');
  var addBtn = root.querySelector('[data-add]');
  var radios = root.querySelectorAll('input[data-option-index]');
  var labels = root.querySelectorAll('[data-option-label]');
  var slides = root.querySelectorAll('[data-slide]');
  var thumbs = root.querySelectorAll('[data-thumb]');
  var variants = [];

  try {
    variants = dataEl ? JSON.parse(dataEl.textContent) : [];
  } catch (e) {
    variants = [];
  }

  function showMedia(id) {
    var found = false;
    slides.forEach(function (s) {
      if (s.getAttribute('data-slide') === String(id)) found = true;
    });
    if (!found) return;
    slides.forEach(function (s) {
      s.hidden = s.getAttribute('data-slide') !== String(id);
    });
    thumbs.forEach(function (t) {
      t.setAttribute('aria-current', t.getAttribute('data-thumb') === String(id) ? 'true' : 'false');
    });
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      showMedia(t.getAttribute('data-thumb'));
    });
  });

  function selectedOptions() {
    var out = [];
    radios.forEach(function (r) {
      if (r.checked) out[Number(r.getAttribute('data-option-index'))] = r.value;
    });
    return out;
  }

  function findVariant(opts) {
    var key = JSON.stringify(opts);
    for (var i = 0; i < variants.length; i++) {
      if (JSON.stringify(variants[i].options) === key) return variants[i];
    }
    return null;
  }

  function setPrice(v) {
    if (!priceEl) return;
    priceEl.textContent = '';
    if (v.compare) {
      var was = document.createElement('s');
      was.className = 'adr-price__was';
      was.textContent = v.compare;
      priceEl.appendChild(was);
    }
    var now = document.createElement('span');
    now.textContent = v.price;
    priceEl.appendChild(now);
  }

  function update() {
    if (!variants.length || !radios.length) return;
    var opts = selectedOptions();
    labels.forEach(function (l) {
      var i = Number(l.getAttribute('data-option-label'));
      if (opts[i] !== undefined) l.textContent = opts[i];
    });
    var v = findVariant(opts);
    if (!v) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
      return;
    }
    if (idInput) idInput.value = v.id;
    setPrice(v);
    if (addBtn) {
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
    }
    if (v.media) showMedia(v.media);
    try {
      window.history.replaceState(null, '', v.url);
    } catch (e) { /* ignore */ }
  }

  radios.forEach(function (r) {
    r.addEventListener('change', update);
  });

  // Quantity buttons
  var qty = root.querySelector('[data-qty]');
  var minus = root.querySelector('[data-qty-minus]');
  var plus = root.querySelector('[data-qty-plus]');
  function setQty(n) {
    if (!qty) return;
    qty.value = Math.max(1, Math.min(99, n || 1));
  }
  if (minus) minus.addEventListener('click', function () { setQty(Number(qty.value) - 1); });
  if (plus) plus.addEventListener('click', function () { setQty(Number(qty.value) + 1); });
})();
